import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  init() {
    gsap.registerPlugin(ScrollTrigger);

    let mm = gsap.matchMedia();
    mm.add('(min-width: 1025px) and (min-height: 730px)', () => {
      const sections = gsap.utils.toArray('.sticky-scroll-media__scrolling');

      sections.forEach((section) => {
        const panel = section.querySelector('.sticky-scroll-media__scrolling-text');
        const panelHolder = section.querySelector('.sticky-scroll-media__scrolling-text-holder');
        let compStyles = window.getComputedStyle(panelHolder);
        let paddingBottom = +compStyles.getPropertyValue('padding-bottom').slice(0, -2);

        const pictures = gsap.utils.toArray('.sticky-scroll-media__item-picture--scroll', section);
        const header = document.querySelector('.mainheader__desktop');

        ScrollTrigger.create({
          trigger: section,
          pin: panel,
          start: 'top top+=' + header.offsetHeight,
          end: 'bottom-=' + (paddingBottom ) + ' top+=' + (pictures[0].offsetHeight + paddingBottom),
          // end: 'bottom ' + ' top+=' + (pictures[0].offsetHeight + paddingBottom*2),
          //   markers: true,
          pinSpacing: false,
        });

        const texts = gsap.utils.toArray('.sticky-scroll-media__scrolling-text__row', section);

        pictures.forEach((picture, i) => {
          ScrollTrigger.create({
            trigger: picture,
            ease: 'power4.out',
            start: 'top 50%',
            end: 'bottom 50%',
            // markers: true,
            // id: i+1,
            onEnter: function() {
              gsap.to(texts[i], {
                opacity: 1,
                y: 0,
                zIndex: 2,
                duration: 0.5,
                stagger: 0.05,
              })
            },
            onLeave: function() {
              if(i < texts.length - 1) {
                gsap.to(texts[i], {
                  opacity: 0,
                  y: -50,
                  duration: 0.5,
                  stagger: 0.05,
                  zIndex: 1,
                })
              }
            },
            onEnterBack: function() {
              gsap.to(texts[i], {
                opacity: 1,
                y: 0,
                duration: 0.5,
                stagger: 0.05,
                zIndex: 2,
              })
            },
            onLeaveBack: function() {
              gsap.to(texts[i], {
                opacity: 0,
                y: 50,
                duration: 0.5,
                stagger: 0.05,
                zIndex: 1,
              })
            },
          })
        })
      })
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/components/gsapSticky.js